module.exports = __webpack_public_path__ + "img/go-build.3a5f8d71.jpg";